/**
 * Schematic catalog rows: [kind, label, category].
 */
import type { SchematicCatalogRow } from './types';

export const SCHEMATIC_CATALOG: SchematicCatalogRow[] = [
  // Power
  ['battery', 'Battery', 'power'],
  ['cell', 'Cell', 'power'],
  ['dcSupply', 'DC Supply', 'power'],
  ['acSupply', 'AC Supply', 'power'],
  ['ground', 'Ground (GND)', 'power'],
  ['earthGround', 'Earth Ground', 'power'],
  ['chassisGround', 'Chassis Ground', 'power'],
  ['signalGround', 'Signal Ground', 'power'],
  ['powerFlag', 'Power Flag', 'power'],
  ['voltageSource', 'Voltage Source', 'power'],
  ['currentSource', 'Current Source', 'power'],
  ['fuse', 'Fuse', 'power'],
  ['circuitBreaker', 'Circuit Breaker', 'power'],
  // Passive
  ['resistor', 'Resistor', 'passive'],
  ['variableResistor', 'Variable Resistor', 'passive'],
  ['potentiometer', 'Potentiometer', 'passive'],
  ['trimmer', 'Trimmer', 'passive'],
  ['thermistorNtc', 'NTC Thermistor', 'passive'],
  ['thermistorPtc', 'PTC Thermistor', 'passive'],
  ['photoresistor', 'Photoresistor (LDR)', 'passive'],
  ['varistor', 'Varistor (MOV)', 'passive'],
  ['capacitor', 'Capacitor', 'passive'],
  ['electrolyticCap', 'Electrolytic Capacitor', 'passive'],
  ['variableCap', 'Var. Capacitor', 'passive'],
  ['inductor', 'Inductor', 'passive'],
  ['variableInductor', 'Variable Inductor', 'passive'],
  ['ferriteBead', 'Ferrite Bead', 'passive'],
  ['transformer', 'Transformer', 'passive'],
  ['autotransformer', 'Autotransformer', 'passive'],
  ['rfCoil', 'RF Coil', 'passive'],
  ['crystal', 'Crystal', 'passive'],
  ['ceramicResonator', 'Ceramic Resonator', 'passive'],
  // Diodes
  ['diode', 'Diode', 'diode'],
  ['schottky', 'Schottky Diode', 'diode'],
  ['zener', 'Zener Diode', 'diode'],
  ['tvs', 'TVS Diode', 'diode'],
  ['led', 'LED', 'diode'],
  ['infraredLed', 'Infrared LED', 'diode'],
  ['laserDiode', 'Laser Diode', 'diode'],
  ['photodiode', 'Photodiode', 'diode'],
  ['bridgeRectifier', 'Bridge Rectifier', 'diode'],
  ['tunnelDiode', 'Tunnel Diode', 'diode'],
  ['varicap', 'Varicap (Varactor)', 'diode'],
  // Transistors
  ['npn', 'NPN BJT', 'transistor'],
  ['pnp', 'PNP BJT', 'transistor'],
  ['nmos', 'N-Channel MOSFET', 'transistor'],
  ['pmos', 'P-Channel MOSFET', 'transistor'],
  ['njfet', 'N-Channel JFET', 'transistor'],
  ['pjfet', 'P-Channel JFET', 'transistor'],
  ['igbt', 'IGBT', 'transistor'],
  ['darlington', 'Darlington', 'transistor'],
  ['phototransistor', 'Phototransistor', 'transistor'],
  ['ujt', 'UJT', 'transistor'],
  // Thyristors
  ['scr', 'SCR', 'thyristor'],
  ['triac', 'TRIAC', 'thyristor'],
  ['diac', 'DIAC', 'thyristor'],
  ['gto', 'GTO', 'thyristor'],
  ['thyristor', 'Thyristor', 'thyristor'],
  // Logic
  ['notGate', 'NOT Gate', 'logic'],
  ['buffer', 'Buffer', 'logic'],
  ['andGate', 'AND Gate', 'logic'],
  ['nandGate', 'NAND Gate', 'logic'],
  ['orGate', 'OR Gate', 'logic'],
  ['norGate', 'NOR Gate', 'logic'],
  ['xorGate', 'XOR Gate', 'logic'],
  ['xnorGate', 'XNOR Gate', 'logic'],
  ['schmittTrigger', 'Schmitt Trigger', 'logic'],
  ['comparator', 'Comparator', 'logic'],
  // Analog
  ['opAmp', 'Operational Amplifier', 'analog'],
  ['instrumentationAmp', 'Instrumentation Amp', 'analog'],
  ['voltageComparator', 'Voltage Comparator', 'analog'],
  ['voltageReference', 'Voltage Reference', 'analog'],
  ['voltageRegulator', 'Voltage Regulator', 'analog'],
  ['ldo', 'LDO Regulator', 'analog'],
  ['buck', 'Buck Converter', 'analog'],
  ['boost', 'Boost Converter', 'analog'],
  ['buckBoost', 'Buck-Boost Converter', 'analog'],
  ['chargePump', 'Charge Pump', 'analog'],
  ['dac', 'DAC', 'analog'],
  ['adc', 'ADC', 'analog'],
  ['pll', 'PLL', 'analog'],
  // Digital
  ['mcu', 'Microcontroller', 'digital'],
  ['mpu', 'Microprocessor', 'digital'],
  ['dsp', 'DSP', 'digital'],
  ['fpga', 'FPGA', 'digital'],
  ['cpld', 'CPLD', 'digital'],
  ['rom', 'ROM', 'digital'],
  ['eeprom', 'EEPROM', 'digital'],
  ['flash', 'Flash Memory', 'digital'],
  ['sram', 'SRAM', 'digital'],
  ['dram', 'DRAM', 'digital'],
  ['rtc', 'Real-Time Clock', 'digital'],
  ['timerIc', 'Timer IC', 'digital'],
  ['counter', 'Counter', 'digital'],
  ['shiftRegister', 'Shift Register', 'digital'],
  ['mux', 'Multiplexer', 'digital'],
  ['demux', 'Demultiplexer', 'digital'],
  ['encoder', 'Encoder', 'digital'],
  ['decoder', 'Decoder', 'digital'],
  ['latch', 'Latch', 'digital'],
  ['flipFlop', 'Flip-Flop', 'digital'],
  // Sensors
  ['tempSensor', 'Temperature Sensor', 'sensor'],
  ['humiditySensor', 'Humidity Sensor', 'sensor'],
  ['pressureSensor', 'Pressure Sensor', 'sensor'],
  ['lightSensor', 'Light Sensor', 'sensor'],
  ['hallSensor', 'Hall Effect Sensor', 'sensor'],
  ['currentSensor', 'Current Sensor', 'sensor'],
  ['voltageSensor', 'Voltage Sensor', 'sensor'],
  ['gasSensor', 'Gas Sensor', 'sensor'],
  ['accelerometer', 'Accelerometer', 'sensor'],
  ['gyroscope', 'Gyroscope', 'sensor'],
  ['magnetometer', 'Magnetometer', 'sensor'],
  ['ultrasonicSensor', 'Ultrasonic Sensor', 'sensor'],
  ['proximitySensor', 'Proximity Sensor', 'sensor'],
  ['pirSensor', 'PIR Sensor', 'sensor'],
  ['touchSensor', 'Touch Sensor', 'sensor'],
  ['microphone', 'Microphone', 'sensor'],
  // Actuators
  ['relay', 'Relay', 'actuator'],
  ['reedRelay', 'Reed Relay', 'actuator'],
  ['solenoid', 'Solenoid', 'actuator'],
  ['dcMotor', 'DC Motor', 'actuator'],
  ['acMotor', 'AC Motor', 'actuator'],
  ['stepperMotor', 'Stepper Motor', 'actuator'],
  ['servoMotor', 'Servo Motor', 'actuator'],
  ['buzzer', 'Buzzer', 'actuator'],
  ['speaker', 'Speaker', 'actuator'],
  ['piezoBuzzer', 'Piezo Buzzer', 'actuator'],
  ['lamp', 'Lamp', 'actuator'],
  ['indicatorLed', 'Indicator LED', 'actuator'],
  ['sevenSegment', 'Seven Segment Display', 'actuator'],
  ['lcd', 'LCD', 'actuator'],
  ['oled', 'OLED Display', 'actuator'],
  // Switches
  ['spst', 'SPST Switch', 'switch'],
  ['spdt', 'SPDT Switch', 'switch'],
  ['dpst', 'DPST Switch', 'switch'],
  ['dpdt', 'DPDT Switch', 'switch'],
  ['pushButtonNo', 'Push Button (NO)', 'switch'],
  ['pushButtonNc', 'Push Button (NC)', 'switch'],
  ['toggleSwitch', 'Toggle Switch', 'switch'],
  ['slideSwitch', 'Slide Switch', 'switch'],
  ['dipSwitch', 'DIP Switch', 'switch'],
  ['rotarySwitch', 'Rotary Switch', 'switch'],
  ['reedSwitch', 'Reed Switch', 'switch'],
  ['limitSwitch', 'Limit Switch', 'switch'],
  ['keySwitch', 'Key Switch', 'switch'],
  ['eStop', 'Emergency Stop', 'switch'],
  // Connectors
  ['connector', 'Connector', 'connector'],
  ['terminalBlock', 'Terminal Block', 'connector'],
  ['header', 'Header', 'connector'],
  ['socket', 'Socket', 'connector'],
  ['jumper', 'Jumper', 'connector'],
  ['usbConnector', 'USB Connector', 'connector'],
  ['rj45', 'RJ45 Connector', 'connector'],
  ['hdmi', 'HDMI Connector', 'connector'],
  ['db9', 'DB9 Connector', 'connector'],
  ['barrelJack', 'Barrel Jack', 'connector'],
  ['coax', 'Coaxial Connector', 'connector'],
  ['sma', 'SMA Connector', 'connector'],
  ['bnc', 'BNC Connector', 'connector'],
  // Comms
  ['uart', 'UART', 'comms'],
  ['spi', 'SPI', 'comms'],
  ['i2c', 'I²C', 'comms'],
  ['canBus', 'CAN Bus', 'comms'],
  ['linBus', 'LIN Bus', 'comms'],
  ['rs232', 'RS-232', 'comms'],
  ['rs485', 'RS-485', 'comms'],
  ['usb', 'USB', 'comms'],
  ['ethernetPhy', 'Ethernet PHY', 'comms'],
  ['bluetooth', 'Bluetooth Module', 'comms'],
  ['wifi', 'Wi-Fi Module', 'comms'],
  ['nfc', 'NFC Module', 'comms'],
  ['zigbee', 'Zigbee Module', 'comms'],
  ['lora', 'LoRa Module', 'comms'],
  ['gps', 'GPS Module', 'comms'],
  // Protection
  ['esdProtection', 'ESD Protection', 'protection'],
  ['polyfuse', 'Polyfuse (PTC)', 'protection'],
  ['mov', 'MOV', 'protection'],
  ['sparkGap', 'Spark Gap', 'protection'],
  ['gdt', 'Gas Discharge Tube', 'protection'],
  ['reversePolarity', 'Reverse Polarity Protection', 'protection'],
  // Test
  ['testPoint', 'Test Point', 'test'],
  ['probe', 'Probe', 'test'],
  ['scopeProbe', 'Oscilloscope Probe', 'test'],
  ['ammeter', 'Ammeter', 'test'],
  ['voltmeter', 'Voltmeter', 'test'],
  ['currentShunt', 'Current Shunt', 'test'],
  // Mechanical
  ['fan', 'Fan', 'mechanical'],
  ['heatsink', 'Heatsink', 'mechanical'],
  ['connectorShield', 'Connector Shield', 'mechanical'],
  ['chassis', 'Chassis', 'mechanical'],
  ['enclosure', 'Enclosure', 'mechanical'],
  ['mountingHole', 'Mounting Hole', 'mechanical'],
  // Misc
  ['netLabel', 'Net Label', 'misc'],
  ['bus', 'Bus', 'misc'],
  ['junction', 'Junction', 'misc'],
  ['noConnect', 'No Connect (NC)', 'misc'],
  ['wire', 'Wire', 'misc'],
  ['shield', 'Shield', 'misc'],
  ['offPageConnector', 'Off-Page Connector', 'misc'],
  ['sheetConnector', 'Sheet Connector', 'misc'],
  ['harness', 'Harness', 'misc'],
  ['cable', 'Cable', 'misc'],
  ['terminal', 'Terminal', 'misc'],
  ['pin', 'Pin', 'misc'],
  ['mountingPad', 'Mounting Pad', 'misc'],
];

